/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, unit: NonNullable<unknown> }} Task_Idle_ForInputs */

const en_task_idle_for = /** @type {(inputs: Task_Idle_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Idle for ${i?.days} ${i?.unit}`)
};

const pt_br2_task_idle_for = /** @type {(inputs: Task_Idle_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parado há ${i?.days} ${i?.unit}`)
};

/**
* | output |
* | --- |
* | "Idle for {days} {unit}" |
*
* @param {Task_Idle_ForInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_idle_for = /** @type {((inputs: Task_Idle_ForInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Idle_ForInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_idle_for(inputs)
	return pt_br2_task_idle_for(inputs)
});